import Grid from "@mui/material/Grid";
import {CEIcon, InstIcon, LotIcon, ManufactureIcon, RefIcon} from "../../icons/icons";
import config from "../../../app/config";
import Modal from "@mui/material/Modal";
import React from "react";
import {useTranslation} from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    modalBody: {
        background: "white",
        color: "black",
        width: "60%",
        left: "20%",
        position: "absolute",
        top: "30px",
        padding: "20px",
        height: "90%",
        overflow: "auto",
        fontSize: "13px",
        borderRadius: "6px",
    },
    modalIcon: {
        fontSize: 38,
    },
    textGridItem: {
        display: "flex",
        alignItems: "center",
        marginBottom: 10,
    },
    iconGridItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 10,
        textAlign: "center",
        fontWeight: "bold",
    },
    iso: {
        fontWeight: "bold",
    },
    icon: {
        cursor: "pointer",
    },
}));


const AboutInfo = ({open, onClose}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <Modal
            open={open}
            onClose={onClose}
        >
            <div className={classes.modalBody}>
                <div className={classes.modalContentView}>
                    <Grid container>
                        <Grid item xs={1} className={classes.iconGridItem}>
                            <CEIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={4} className={classes.iconGridItem}>
                            CE Mark
                        </Grid>
                        <Grid item xs={7} className={classes.textGridItem}>
                            CE Mark (developed in compliance with Directive 93/42/EEC for Class I devices). Made in
                            the United Kingdom
                        </Grid>
                        <Grid item xs={1} className={classes.iconGridItem}>
                            <RefIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={4} className={classes.iconGridItem}>
                            {t("Device reference")}
                        </Grid>
                        <Grid item xs={7} className={classes.textGridItem}>
                            Agyle R1
                        </Grid>
                        <Grid item xs={1} className={classes.iconGridItem}>
                            <LotIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={4} className={classes.iconGridItem}>
                            Version
                        </Grid>
                        <Grid item xs={7} className={classes.textGridItem}>
                            {t(`Version ${config.version || 2.0}`)}
                        </Grid>
                        <Grid item xs={1} className={classes.iconGridItem}>
                            <InstIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={4} className={classes.iconGridItem}>
                            {t("Instructions before use")}
                        </Grid>
                        <Grid item xs={7} className={classes.textGridItem}>
                            {t("Please read this instruction manual thoroughly before using the device")}
                        </Grid>
                        <Grid item xs={1} className={classes.iconGridItem}>
                            <ManufactureIcon className={classes.modalIcon}/>
                        </Grid>
                        <Grid item xs={4} className={classes.iconGridItem}>
                            {t("Manufacturer")}
                        </Grid>
                        <Grid item xs={7} className={classes.textGridItem}>
                            SoftJump Ltd
                            <br/>
                            25 Moorgate, London, England, EC2R 6AY
                        </Grid>
                    </Grid>
                    <br/>
                    <div>
                        {t("This device fulfils the provisions of the European Commission (EC) Directive 93/42/EEC (Medical Devices Directive)")}
                    </div>
                    <br/>
                    <div>
                        {t("This device has been developed under the strict quality system of SoftJump Ltd.")}
                    </div>
                    <br/>
                    <div>
                        {t("This software product has been designed according to")}:
                        <br/>
                        <br/>
                        <Grid container justifyContent="center" alignItems="center" spacing={2}>
                            <Grid item xs={3} className={classes.iso}>
                                ISO 13485:2016
                            </Grid>
                            <Grid item xs={9}>
                                Medical devices – Quality Management Systems – Requirements for regulatory purposes
                            </Grid>
                            <Grid item xs={3} className={classes.iso}>
                                DCB0129:2018
                            </Grid>
                            <Grid item xs={9}>
                                Application of clinical safety risk management to the manufacture of health IT
                                systems
                            </Grid>
                            <Grid item xs={3} className={classes.iso}>
                                DCB0160:2018
                            </Grid>
                            <Grid item xs={9}>
                                Clinical Risk Management: its Application in the Deployment and Use of Health IT
                                Systems
                            </Grid>
                            <Grid item xs={3} className={classes.iso}>
                                IEC 62304:2006
                                <br/>
                                Amd 1:2015
                            </Grid>
                            <Grid item xs={9}>
                                Medical device software – Software lifecycle processes
                            </Grid>
                            <Grid item xs={3} className={classes.iso}>
                                ISO 15233-1:2012
                            </Grid>
                            <Grid item xs={9}>
                                Medical Devices: Symbols to be used with medical device labels, labelling and
                                information to be supplied - Part 1: General requirements
                            </Grid>
                            <Grid item xs={3} className={classes.iso}>
                                ISO 14971:2012
                            </Grid>
                            <Grid item xs={9}>
                                Medical Devices - Application of risk management to medical devices
                            </Grid>
                        </Grid>
                    </div>
                    <br/>
                </div>
            </div>
        </Modal>
    );
};

export default AboutInfo;